import MyAdvertisement from "../../components/user/MyAdvertisement";
import UserLayout from "../../components/UserLayout";

const MyAdvertisementPage = () => {
    return (
        <UserLayout>
            <MyAdvertisement />
        </UserLayout>
    );
}

export default MyAdvertisementPage;